import { Trans } from "react-i18next";

export default function ChallengeTranslateContent({ ownerChallenge, status }) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.challengeTranslatedSuccess"
        : status === "pending" ?
          "notifications.challengeTranslated"
        : "notifications.challengeTranslatedFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  );
}
